/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ===========================================================================
   INEJ CRO — copy-code offers, offers swipe dots, sticky mobile add-to-cart
   =========================================================================== */
(function () {
  'use strict';

  /* ---- copy to clipboard (with fallback) ---- */
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      resolve();
    });
  }

  // Delegated: tap an offer to copy its code (attached once).
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-inej-copy]') : null;
    if (!el) return;
    copyText(el.getAttribute('data-inej-copy')).then(function () {
      el.classList.add('is-copied');
      var label = el.querySelector('.InejOffer__CopyLabel');
      var prev = label ? label.textContent : null;
      if (label) label.textContent = 'Copied!';
      setTimeout(function () {
        el.classList.remove('is-copied');
        if (label && prev !== null) label.textContent = prev;
      }, 1800);
    });
  });

  /* ---- offers: update dots while swiping ---- */
  function initOffers(scope) {
    (scope || document).querySelectorAll('[data-inej-offers].InejOffers--multi').forEach(function (off) {
      if (off.dataset.inejBound) return;
      off.dataset.inejBound = '1';
      var track = off.querySelector('[data-inej-offers-track]');
      var dots = off.querySelectorAll('.InejOffers__Dot');
      if (!track || !dots.length) return;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
        });
      }, { passive: true });
    });
  }

  /* ---- sticky mobile add-to-cart ---- */
  function initSticky(scope) {
    (scope || document).querySelectorAll('[data-inej-sticky-atc]').forEach(function (bar) {
      if (bar.dataset.inejBound) return;
      bar.dataset.inejBound = '1';
      var section = bar.closest('.shopify-section') || document;
      var atc = section.querySelector('.ProductForm__AddToCart');
      if (!atc) return;
      var stickyBtn = bar.querySelector('[data-inej-sticky-add]');
      var stickyPrice = bar.querySelector('[data-inej-sticky-price]');

      // Mirror the live price (updates on variant change).
      var priceList = section.querySelector('.ProductMeta__PriceList');
      if (priceList && stickyPrice) {
        var sync = function () {
          var p = priceList.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
          if (p) stickyPrice.textContent = p.textContent.trim();
        };
        sync();
        try { new MutationObserver(sync).observe(priceList, { childList: true, subtree: true, characterData: true }); } catch (e) {}
      }

      // Sticky button triggers the real (variant-aware) add to cart.
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
      }

      // Reveal only after the real add-to-cart has scrolled above the viewport.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var past = !en.isIntersecting && en.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', past);
            bar.setAttribute('aria-hidden', past ? 'false' : 'true');
          });
        }, { threshold: 0 }).observe(atc);
      }
    });
  }

  /* ---- collection card mobile swipe gallery ---- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-inej-gallery]').forEach(function (g) {
      if (g.dataset.inejBound) return;
      g.dataset.inejBound = '1';
      var track = g.querySelector('[data-inej-gallery-track]');
      if (!track) return;
      var segs = g.querySelectorAll('.InejCardGallery__Seg');
      var loaded = false;
      function loadRest() {
        if (loaded) return;
        loaded = true;
        track.querySelectorAll('img[data-inej-src]').forEach(function (img) {
          img.setAttribute('data-src', img.getAttribute('data-inej-src'));
          img.removeAttribute('data-inej-src');
          img.classList.add('Image--lazyLoad');
        });
        if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      }
      // Extra images load only once the shopper engages this card.
      track.addEventListener('touchstart', loadRest, { passive: true, once: true });
      track.addEventListener('pointerdown', loadRest, { passive: true, once: true });
      var ticking = false;
      track.addEventListener('scroll', function () {
        loadRest();
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (!segs.length) return;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          segs.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        });
      }, { passive: true });
    });
  }

  /* ---- announcement bar: auto-rotate + swipe ---- */
  function initAnnouncement(scope) {
    (scope || document).querySelectorAll('[data-inej-announcement].AnnouncementBar--multi').forEach(function (bar) {
      if (bar.dataset.inejBound) return;
      bar.dataset.inejBound = '1';
      var track = bar.querySelector('[data-inej-announcement-track]');
      if (!track || track.children.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var speed = (parseFloat(bar.getAttribute('data-inej-announcement-speed')) || 3) * 1000;
      var i = 0, timer = null, ticking = false;
      function go() {
        i = (i + 1) % track.children.length;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function start() { if (!reduce && !timer) timer = setInterval(go, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      // keep the index in sync if the shopper swipes manually
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; i = Math.round(track.scrollLeft / track.clientWidth); });
      }, { passive: true });
      bar.addEventListener('pointerenter', stop);
      bar.addEventListener('pointerleave', start);
      bar.addEventListener('touchstart', stop, { passive: true });
      bar.addEventListener('touchend', function () { setTimeout(start, 4000); }, { passive: true });
      start();
    });
  }

  function initAll(scope) { initOffers(scope); initSticky(scope); initGallery(scope); initAnnouncement(scope); }

  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();